import { Grid } from 'theme-ui';
import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/ListingFooter/ListingFooter.styles';
import Button from '@components/Button/Button';
import CategoryGalleryStore from '@features/cms/components/categories/CategoryGalleryBlock/mobx/store/CategoryGalleryStore';
import GalleryProgressLine from '@features/cms/components/categories/CategoryGalleryBlock/components/GalleryProgressLine/GalleryProgressLine';
type PropsType = {
  categoryStore: CategoryGalleryStore;
};
const ListingFooter = ({
  categoryStore
}: PropsType) => {
  const {
    currentCount,
    allImagesCount,
    loadRow
  } = categoryStore;
  const {
    t
  } = useTranslation('common');
  return <Grid columns={1} sx={styles.bottomRow}>
      <div sx={styles.progressLineSize}>
        <GalleryProgressLine actualCount={currentCount} maxCount={allImagesCount} />
      </div>
      {currentCount !== allImagesCount && <Grid columns={1} sx={styles.buttonCenter}>
          <Button cy="VoxButtonPagination" variant="outlined" variantColor="dark" size="small" onClick={loadRow}>
            {t('seeMore')}
          </Button>
        </Grid>}
    </Grid>;
};
export default ListingFooter;